import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/junli/work/fun/hooks/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from 'docz';
import { useImage } from "../../index";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "useimage"
    }}>{`useImage`}</h1>
    <p>{`加载图片`}</p>
    <hr />
    <h2 {...{
      "id": "api"
    }}>{`API`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`const [
  img: HTMLImageElement,
  status: 'loading' | 'loaded' | 'error' // 加载状态
] = useImage(
  src: string, // 图片链接
  crossOrigin?: string
);
`}</code></pre>
    <hr />
    <h2 {...{
      "id": "demo"
    }}>{`DEMO`}</h2>
    <Playground __position={2} __code={'() => {\n  const [img, status] = useImage(\n    \'https://wxt.sinaimg.cn/mw1024/62194d50ly1g8ayqntoqpj207i0a0750.jpg\',\n  )\n  return (\n    <div>\n      <h3>加载状态：{status}</h3>\n      <div style={{ width: \'300px\', height: \'400px\' }}>\n        {status === \'loaded\' && <img src={img.src} />}\n      </div>\n    </div>\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      Playground,
      useImage,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  {() => {
        const [img, status] = useImage('https://wxt.sinaimg.cn/mw1024/62194d50ly1g8ayqntoqpj207i0a0750.jpg');
        return <div>
        <h3>加载状态：{status}</h3>
        <div style={{
            width: '300px',
            height: '400px'
          }}>
          {status === 'loaded' && <img src={img.src} />}
        </div>
      </div>;
      }}
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      